<!-- =========================================================================================
	Thỏa thuận sử dụng
========================================================================================== -->

<template>
  <div v-if="isShow" id="agreement_wrapper"></div>
</template>

<script>
import AgreementLicenseAPI from '@/apis/eTask/agreementLicenseAPI.js';
import { ModuleContext } from '@/stores/module-const';

const termUserIdKey = '_cegov_termUserId';

export default {
  name: 'AgreementLicense',
  components: {},

  computed: {
    context() {
      return this.$store.state[ModuleContext];
    },
  },
  mounted() {
    const me = this;
  },

  created() {
    // load lib show form chấp nhận thỏa thuận
    const me = this;
    // dựa vào config để biết hiển thị popup thỏa thuận theo luồng cũ hay mới
    if (
      !window._isHideAgreementLicense &&
      window._isHideAgreementLicenseVersion == 'v2'
    ) {
      const scriptElm = document.createElement('script');

      const link = window._personalAgreementLink;
      if (link) {
        document.head.appendChild(scriptElm);
        scriptElm.setAttribute('src', link);
        scriptElm.onload = async function () {
          await me.getAgreementAndPrivacy();
        };
      }
    }
  },
  data() {
    return {
      isShow: false,
    };
  },

  methods: {
    /**
     * Lấy các thỏa thuận chưa xác nhận
     */
    async getAgreementAndPrivacy() {
      let me = this;
      let termUserIdKey = 'taskgo_termUserId';
      try {
        const termUserId = sessionStorage.getItem(termUserIdKey);
        const userId = me?.context?.User?.UserID;
        //
        if (termUserId == userId && termUserId) {
          return;
        }

        let payload = {
          UserId: me?.context?.User?.UserID,
          IsAdmin: true, // mặc định là true để lấy tất cả các thỏa thuận
          budgetCode: me?.context?.User?.OrganizationUnitCode,
          misaidKey: me?.context?.User?.MISAID,
        };

        // nếu không có userId thì không cần gọi api
        if(payload == null || payload.UserId == null) {
          return;
        }
        
        me.$ms.commonFn.mask();

        const result = await AgreementLicenseAPI.checkAgreementAppV2(payload);
        
        me.$ms.commonFn.unmask();
        
        // nếu đã submit điều khoản sử dụng và chính sách riêng tư thì k submit mua hàng
        if (
          result?.TermsOfService ||
          result?.Privacy ||
          result?.TermsOfPurchase
        ) {
          let config = {
            language: 'vi',
            AcceptAgreement: function () {
              me.isShow = false;

              sessionStorage.setItem(termUserIdKey, me?.context?.User?.UserID);

              me.confirm(
                result?.TermsOfService?.Id,
                result?.TermsOfPurchase?.Id,
                result?.Privacy?.Id
              );
            },
            confirmer: {
              firstName: me?.context?.User?.FullName?.split(' ')
                .slice(0, -1)
                .join(' '),
              lastName: me?.context?.User?.FullName?.split(' ')
                .slice(-1)
                .join(' '),
              fullName:
                me?.context?.User?.FullName?.split(' ').slice(0, -1).join(' ') +
                ' ' +
                me.context?.User?.FullName?.split(' ').slice(-1).join(' '),
            },
            nameProduct: 'MISA Taskgo',
          };
          if (result.TermsOfService) {
            config = {
              ...config,
              termsOfServiceURI: result?.TermsOfService?.Uri,
            };
          }

          if (result.Privacy) {
            config = { ...config, privacyURI: result?.Privacy?.Uri };
          }
          // Thỏa thuận mua hàng
          if (result.TermsOfPurchase) {
            config = {
              ...config,
              termsOfPurchaseURI: result?.TermsOfPurchase?.Uri,
            };
          }
          // Nếu không phải admin và chưa xác nhận thì show cảnh báo
          if (result?.TermsOfPurchase && !me?.context?.User?.IsAdmin) {
            me.$router.push('/agreement-expire');
            return;
          }
          me.isShow = true;
          window.MISAAgreementLib.init(config);
        } else {
          sessionStorage.setItem(termUserIdKey, me?.context?.User?.UserID);
        }
      } catch (e) {
        console.log(e);
        me.isShow = false;
        me.$ms.commonFn.unmask();
      }
    },

    /**
     * Xác nhận đống ý Tuhar thuận sử dụng và chính sách quyền riêng tư
     */
    confirm(termsOfServiceId, termsOfPurchaseId, privacyId) {
      const me = this;
      try {
        let payload = {
          Email: me.context?.User?.Email,
          FirstName: me?.context?.User?.FullName?.split(' ')
            .slice(0, -1)
            .join(' '),
          LastName: me?.context?.User?.FullName?.split(' ').slice(-1).join(' '),
          fullName:
            me?.context?.User?.FullName?.split(' ').slice(0, -1).join(' ') +
            ' ' +
            me.context?.User?.FullName?.split(' ').slice(-1).join(' '),
          PhoneNumber: me?.context?.User?.Mobile,
          TermsOfServiceId: termsOfServiceId,
          PrivacyId: privacyId,
          TermsOfPurchaseId: termsOfPurchaseId,
          UserId: me?.context?.User?.UserID,
          BudgetCode: me?.context?.User?.OrganizationUnitCode,
          IsAdmin: me.context?.User?.IsAdmin,
          CompanyAddress: '',
          TaxCode: '',
          companyName: me?.context?.User?.OrganizationUnitName,
        };

        if (me.context.User.MISAID != '00000000-0000-0000-0000-000000000000') {
          payload.MisaIdKey = me.context.User.MISAID;
        }

        me.$ms.commonFn.mask();
        
        AgreementLicenseAPI.saveAgreementV2(payload).then((result) => {
          me.$ms.commonFn.unmask();
          if (
            result.Privacy ||
            result.TermsOfService ||
            result.TermsOfPurchase
          ) {
            me.$toast.success('Xác nhận thành công');
          } else {
            me.$toast.error('Xác nhận thất bại');
          }
        });
      } catch (e) {
        console.log(e);
        me.isShow = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#agreement_wrapper {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: black;
  z-index: 13;
  opacity: 0.2;
}
</style>
